export default "__VITE_ASSET__6U6ePa2V__"